import { useState } from "react";
import {post} from "../../utils/frRequest";


interface IExcluirConta {
  isLoading: boolean;
  excluirConta: (args: { mensagem: string }) => Promise<void>;
}

export const useExcluirConta = (): IExcluirConta => {
  const [isLoading, setIsLoading] = useState(false);

  const excluirConta = async (args: { mensagem: string }) => {
    setIsLoading(true);
    let success = false;
    let error = '';

    try {
      const res = await post(
        '/veApi/vet_experts/excluir_conta',
        args,
      );
      success = res.success;
      error = res.error;
    } catch (err) {
      console.error('Erro inesperado ao excluir conta', err);
      throw new Error('Ocorreu um erro inesperado ao tentar excluir sua conta.');
    } finally {
      setIsLoading(false);
    }

    if (!success) {
      throw new Error(error);
    }
  };

  return {
    isLoading,
    excluirConta,
  }
}